import React, { useEffect, useMemo, useState } from 'react';
import { loadPhotoIndex } from '../../data/photoFileNames';

const imageFileNames: string[] = [
  'IMG_4844.JPG',
  'IMG_0143.jpeg',
  'IMG_0041.jpeg',
  'IMG_9440.jpeg',
  'IMG_9063.jpeg',
  'IMG_9051.jpeg',
  'IMG_9036.jpeg',
  'IMG_8882.jpeg',
  'IMG_8191.jpeg',
  'IMG_7316.jpeg',
  'IMG_4680.jpeg',
  'IMG_6522.jpeg',
  'IMG_6510.jpeg',
  'IMG_6471.jpeg',
  'IMG_6414.jpeg',
  'IMG_6313.jpeg',
  'IMG_6301.jpeg',
  'IMG_6236.jpeg',
  'IMG_5952.jpeg',
  'IMG_5877.jpeg',
  'IMG_5817.jpeg',
  'IMG_5784.jpeg',
  'IMG_5615.jpeg',
  'IMG_5579.jpeg',
  'IMG_5458.jpeg',
  'IMG_5456.jpeg',
  'IMG_5132.jpeg',
  'IMG_5091.jpeg',
  'IMG_5079.jpeg',
  'IMG_5029.jpeg',
  'IMG_5014.jpeg',
  'IMG_4679.jpeg',
  'IMG_4502.jpeg',
  'IMG_4491.jpeg',
  'IMG_4480.jpeg',
  'IMG_4476.jpeg',
  'IMG_3774.jpeg',
  'IMG_3760.jpeg',
  'IMG_1748.jpeg',
  'IMG_1469.jpeg',
  'IMG_1328.jpeg',
  'PXL_20240621_002133991_Original.JPG',
  'PXL_20240621_191321560.MP_Original.JPG',
  'PXL_20240621_011851578.MP_Original.JPG',
  'PXL_20240620_183540194.MP_Original.JPG',
  'IMG_8170 Copy.JPG',
  'IMG_7047.JPG',
  'IMG_6299.JPG',
  'PXL_20231007_162903713_Original.JPG',
  'IMG_5509.JPG',
  'PXL_20231006_020831800_Original.JPG',
  'IMG_5020.JPG',
  'IMG_4259.JPG',
  'IMG_1440.JPG',
  'IMG_1448.JPG',
];

const Photos: React.FC = () => {
  const [selectedSrc, setSelectedSrc] = useState<string | null>(null);

  const imageSrcs = useMemo(() => {
    return imageFileNames.map((name) => `/photos/${encodeURIComponent(name)}`);
  }, []);

  // Load dynamic list if available
  useEffect(() => {
    let mounted = true;
    loadPhotoIndex().then((names) => {
      if (!mounted || names.length === 0) return;
      const srcs = names.map((n) => `/photos/${encodeURIComponent(n)}`);
      setSelectedSrc(null);
      // Replace the constant list by setting state via a quick trick: local state for srcs
      setDynamicSrcs(srcs);
    });
    return () => { mounted = false; };
  }, []);

  const [dynamicSrcs, setDynamicSrcs] = useState<string[] | null>(null);
  const srcsToRender = dynamicSrcs ?? imageSrcs;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setSelectedSrc(null);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-wedding text-gray-900">Photos</h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {srcsToRender.map((src) => (
            <button
              key={src}
              className="relative overflow-hidden rounded-lg bg-gray-100 group focus:outline-none focus:ring-2 focus:ring-primary-500"
              onClick={() => setSelectedSrc(src)}
            >
              <img
                src={src}
                alt="Wedding memory"
                loading="lazy"
                className="w-full h-48 object-cover transition-transform duration-200 ease-out group-hover:scale-[1.02]"
              />
            </button>
          ))}
        </div>

        {selectedSrc && (
          <div
            className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedSrc(null)}
          >
            <div className="max-w-6xl w-full max-h-[90vh]">
              <img
                src={selectedSrc}
                alt="Selected wedding memory"
                className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Photos; 